document.addEventListener('change', function(event) {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;
  const option = select.selectedOptions[0];
  const price = document.getElementById('ProductPrice');
  const button = document.querySelector('[data-add-button]');
  if (price && option) price.textContent = option.dataset.price || price.textContent;
  if (button && option) {
    button.disabled = option.dataset.available !== 'true';
    button.textContent = button.disabled ? 'Sold out' : 'Add to cart';
  }
});
